import { EventStatusEnum } from '../../types/enums/center-event/event-status.enum'
import { EventTypeEnum } from '../../types/enums/center-event/event-type.enum'
import { CenterEventFilter } from '../../types/models/center-event/center-event'

export const transformCenterEventsFiltersToUrl = (filters?: CenterEventFilter): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.countryIds && filters.countryIds.length > 0)
    searchParams.set('countryIds', filters.countryIds.join(','))

  if (filters.types && filters.types.length > 0) searchParams.set('types', filters.types.join(','))

  if (filters.studentIds && filters.studentIds.length > 0)
    searchParams.set('studentIds', filters.studentIds.join(','))

  if (filters.assignedToIds && filters.assignedToIds.length > 0)
    searchParams.set('assignedToIds', filters.assignedToIds.join(','))

  if (filters.inactiveDuration)
    searchParams.set('inactiveDuration', filters.inactiveDuration.toString())

  if (filters.startDate) searchParams.set('startDate', filters.startDate)

  if (filters.endDate) searchParams.set('endDate', filters.endDate)

  if (filters.lastActivity) searchParams.set('lastActivity', filters.lastActivity)

  if (filters.periodIds && filters.periodIds.length > 0)
    searchParams.set('periodIds', filters.periodIds.join(','))

  if (filters.centerIds && filters.centerIds.length > 0)
    searchParams.set('centerIds', filters.centerIds.join(','))

  if (filters.createdAt) searchParams.set('createdAt', filters.createdAt)

  if (filters.olIds && filters.olIds.length > 0) searchParams.set('olIds', filters.olIds.join(','))

  if (filters.statuses && filters.statuses.length > 0)
    searchParams.set('status', filters.statuses.join(','))

  return searchParams.toString()
}

export const transformUrlToCenterEventsFilters = (
  searchParams: URLSearchParams
): CenterEventFilter => {
  const filters: CenterEventFilter = {}

  const countryIds = searchParams.get('countryIds')
  if (countryIds) filters.countryIds = countryIds.split(',').map(Number)

  const types = searchParams.get('types')
  if (types) filters.types = types.split(',') as EventTypeEnum[]

  const studentIds = searchParams.get('studentIds')
  if (studentIds) filters.studentIds = studentIds.split(',').map(Number)

  const assignedToIds = searchParams.get('assignedToIds')
  if (assignedToIds) filters.assignedToIds = assignedToIds.split(',').map(Number)

  const inactiveDuration = searchParams.get('inactiveDuration')
  if (inactiveDuration) filters.inactiveDuration = parseInt(inactiveDuration, 10)

  const startDate = searchParams.get('startDate')
  if (startDate) filters.startDate = startDate

  const endDate = searchParams.get('endDate')
  if (endDate) filters.endDate = endDate

  const lastActivity = searchParams.get('lastActivity')
  if (lastActivity) filters.lastActivity = lastActivity

  const periodIds = searchParams.get('periodIds')
  if (periodIds) filters.periodIds = periodIds.split(',').map(Number)

  const centerIds = searchParams.get('centerIds')
  if (centerIds) filters.centerIds = centerIds.split(',').map(Number)

  const createdAt = searchParams.get('createdAt')
  if (createdAt) filters.createdAt = createdAt

  const olIds = searchParams.get('olIds')
  if (olIds) filters.olIds = olIds.split(',').map(Number)

  const statuses = searchParams.get('statuses')
  if (statuses) filters.statuses = statuses.split(',') as EventStatusEnum[]

  return filters
}
